import React from "react";
import styles from "./SHProducts.module.scss";

const TYPES = {
  FORMULARY: "FORMULARY",
  PRODUCT: "PRODUCT",
  VIEW_PRODUCT: "VIEW_PRODUCT",
};

export const MaterialCard = ({ material, onClick, type }) => {
  const { materialId, materialNumber, materialDesc, packageQuantity, productFamilyDesc, materialDescription } = material;

  const title = type === TYPES.FORMULARY || type === TYPES.VIEW_PRODUCT ? productFamilyDesc : materialNumber;
  const description = type === TYPES.FORMULARY || type === TYPES.VIEW_PRODUCT ? materialDescription : materialDesc;

  const handleClick = () => onClick?.(materialId);

  return (
    <div
      className={styles.material_card}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleClick()}
    >
      <div className={styles.material_content}>
        <p className={styles.material_number}>{title}</p>
        <p className={styles.material_desc}>{description}</p>
        {packageQuantity && <p className={styles.material_package}>Packaging: {packageQuantity}</p>}
        {type === TYPES.VIEW_PRODUCT && <p className={styles.material_package}>{materialNumber}</p>}
      </div>
      <span className={styles.material_chevron} aria-hidden="true">
        ›
      </span>
    </div>
  );
};
